import { BillingApiError, billingErrorMessage } from "./billingApi.js";

// action : « validate » pour une validation suivie (préchargements), sinon une sauvegarde.
export function unconfirmedConsolidationSave(cause, action = "save") {
  const subject = action === "validate" ? "La validation" : "La sauvegarde";
  return Object.assign(new Error(`${subject} n’a pas pu être confirmée. Vérifiez la journée avant de réessayer.`, { cause }),
    { saveUnconfirmed: true, unconfirmedAction: action });
}

// fetch (rather than EventSource) preserves POST bodies and Supabase authorization.
export async function readConsolidationSaveStream(response, onProgress) {
  const reader = response.body?.getReader();
  if (!reader) throw unconfirmedConsolidationSave();
  const decoder = new TextDecoder();
  let buffer = "";
  try {
    while (true) {
      const { value, done } = await reader.read();
      buffer += decoder.decode(value, { stream: !done });
      let boundary;
      while ((boundary = /\r?\n\r?\n/.exec(buffer))) {
        const frame = buffer.slice(0, boundary.index);
        buffer = buffer.slice(boundary.index + boundary[0].length);
        const lines = frame.split(/\r?\n/);
        const event = lines.find(line => line.startsWith("event:"))?.slice(6).trim();
        const data = lines.filter(line => line.startsWith("data:")).map(line => line.slice(5).trimStart()).join("\n");
        if (!data || !["progress", "result", "error"].includes(event)) continue;
        const payload = JSON.parse(data);
        if (event === "error") throw new BillingApiError(
          billingErrorMessage(payload.payload, "Enregistrement refusé par le serveur, sans raison donnée. Rechargez la journée, puis réessayez."), payload.status, payload.payload);
        if (event === "result") {
          if (!payload?.id) throw unconfirmedConsolidationSave();
          return payload;
        }
        if (["verify", "photo", "save"].includes(payload.key) && ["running", "completed", "skipped"].includes(payload.status)) {
          onProgress?.(payload.key, payload.status);
        }
      }
      if (done) throw unconfirmedConsolidationSave();
    }
  } catch (error) {
    if (error instanceof BillingApiError || error.saveUnconfirmed) throw error;
    throw unconfirmedConsolidationSave(error);
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}
